// @flow

import React from 'react';

// prettier-ignore
import { Router as ReactRouter, Switch, Route, Redirect} from 'react-router-dom';
import { createBrowserHistory } from 'history';

// import ScrollToTop from './components/ScrollToTop';

type Props = {
  routes: Array<{
    path: string,
    component: any,
  }>,
  notFound: any,
  children: (page: any) => any,
};

export const history = createBrowserHistory();

const Router = (props: Props) => (
  <ReactRouter history={history}>
    {props.children(() => (
      <Switch>
        <Route path="/" strict exact>
          <Redirect to="/ru/" />
        </Route>
        {props.routes.map(route => (
          <Route
            key={route.path}
            path={`/:locale(ru|ro)${route.path}`}
            component={route.component}
            sensitive
            strict
            exact
          />
        ))}
        <Route path="*" component={props.notFound} />
      </Switch>
    ))}
  </ReactRouter>
);

export default Router;



// WEBPACK FOOTER //
// ./src/providers/Router/index.js